/* eslint indent: 0, standard/no-callback-literal:0 */

import app from '../app.jsx'
import _ from 'lodash'

function _getProjects (contactId, callback) {
  if (contactId) {
    const params = {
      query: {
        contactId: contactId
      }
    }

    params.query.status = { $nin: ['closed', 'estimate'] }

    app
      .service('/api/project')
      .find(params)
      .then(result => {
        if (result) {
          const options = result.data.map(obj => ({
            label: [
              app.projectSetting &&
                app.projectSetting.useProjectNo &&
                obj.projectNumber,
              obj.title
            ]
              .filter(Boolean)
              .join(' | '),
            value: obj.id,
            phases: obj.budget ? obj.budget.phases : []
          }))

          callback(options)
        } else {
          callback([], [])
        }
      })
      .catch(err => {
        app.debug('PageExpense: _getProjects err', err)
        callback([], [])
      })
  } else {
    callback([], [])
  }
}

function _getContactBudgetItems (
  contactId,
  keyword,
  excludeIds,
  selectedSupplierId,
  callback
) {
  const detailParams = {
    query: {
      type: 'get-by-supplier',
      contactId: contactId,
      keyword: keyword,
      excludeBudgetItemIds: excludeIds,
      selectedSupplierId: selectedSupplierId || null
    }
  }

  app
    .service('/api/expense/detail')
    .find(detailParams)
    .then(expenseDetailRes => {
      const expenseItems = expenseDetailRes.expenseItems
      expenseItems.forEach(item => {
        item.invoiceTotal = 0
        item.selected = false
      })

      callback(expenseItems)
    })
    .catch(err => {
      app.debug('PageExpense: _getContactBudgetItems err', err)
      callback([])
    })
}

function _getExpenseDetails (expenseId, callback) {
  const detailParams = {
    query: {
      type: 'get-by-expense',
      expenseId: expenseId,
      keyword: '',
      excludeBudgetItemIds: []
    }
  }

  app
    .service('/api/expense/detail')
    .find(detailParams)
    .then(expenseDetailRes => {
      const expenseItems = expenseDetailRes.expenseItems
      expenseItems.forEach(item => {
        item.invoiceTotal = item.total
        item.selected = true
      })

      callback(expenseDetailRes.expense, expenseItems)
    })
    .catch(err => {
      app.debug('PageExpense: _getContactBudgetItems err', err)
      callback(null, [])
    })
}

function _onAddBudgetExpense (supplierId, expenseObj, callback) {
  let newItem = null
  const createObj = {
    contactId: expenseObj.contactId,
    projectId: expenseObj.projectId,
    phaseNo: expenseObj.phaseNo,
    groupNo: 0,
    orderNo: 0,
    type: 'expense-activity',
    title: expenseObj.title,
    description: expenseObj.description,
    total: expenseObj.total || 0,
    percentage: 0,
    spentAmount: 0,
    noHours: 0,
    pricePerHour: 0,
    bUseTotal: true,
    sellingPrice: expenseObj.sellingPrice || 0,
    fromDate: expenseObj.fromDate ? expenseObj.fromDate : null,
    toDate: expenseObj.toDate ? expenseObj.toDate : null,
    schedules: [],
    skills: [],
    allcoatedHours: 0,
    markupPercentage: expenseObj.markupPercentage || 0
  }

  const findParams = {
    query: {
      contactId: expenseObj.contactId,
      projectId: expenseObj.projectId,
      phaseNo: expenseObj.phaseNo
    }
  }

  app
    .service('/api/project/budgetitem')
    .find(findParams)
    .then(findRes => {
      const maxGroup = _.maxBy(findRes.data, 'groupNo')
      const groupNo = maxGroup ? maxGroup.groupNo : 1
      let orderNo = 0

      findRes.data.map((budgItem, _idx) => {
        if (budgItem.groupNo === groupNo) {
          if (budgItem.orderNo > orderNo) {
            orderNo = budgItem.orderNo
          }
        }
      })

      createObj.groupNo = groupNo
      createObj.orderNo = orderNo + 1

      return app.service('/api/project/budgetitem').create(createObj)
    })
    .then(result => {
      newItem = _.cloneDeep(result)
      newItem.budgetItemId = result.id
      newItem.budgetItem = {
        title: result.title,
        bUseTotal: result.bUseTotal,
        noHours: result.noHours,
        pricePerHour: result.pricePerHour,
        total: result.total
      }
      newItem.id = null
      newItem.title = result.title
      newItem.total = result.total
      newItem.invoiceTotal = result.total
      newItem.selected = true

      const supplierObj = {
        contactId: supplierId,
        projectId: result.projectId,
        budgetItemId: result.id,
        purchaseOrderId: null
      }

      return app.service('/api/project/budgetitemsupplier').create(supplierObj)
    })
    .then(supplierRes => {
      newItem.budgetItemSupplierId = supplierRes.id

      const itemParams = {
        query: {
          $client: {
            subObjects: {
              contact: ['id', 'company'],
              project: ['id', 'title']
            }
          }
        }
      }

      return app
        .service('/api/project/budgetitem')
        .get(newItem.budgetItemId, itemParams)
    })
    .then(budgetItemRes => {
      newItem.project = budgetItemRes.project
      newItem.contact = budgetItemRes.contact

      const projectParams = {
        query: {
          $client: {
            subObjects: {
              contact: ['company']
            }
          }
        }
      }

      return app
        .service('/api/project')
        .get(expenseObj.projectId, projectParams)
    })
    .then(projectRes => {
      newItem.project = projectRes
      projectRes.budget.phases.map((phase, idx) => {
        if (newItem.phaseNo && newItem.phaseNo - 1 === idx) {
          phase.total = phase.total + newItem.total
          phase.spentAmount = phase.spentAmount + newItem.spentAmount
        }
      })

      const updateObj = {
        budget: {
          phases: projectRes.budget.phases,
          total: parseFloat(
            (projectRes.budget.total + newItem.total).toFixed(2)
          ),
          totalSellingPrice: parseFloat(
            (
              projectRes.budget.totalSellingPrice + newItem.sellingPrice
            ).toFixed(2)
          ),
          totalSpent: parseFloat(
            (projectRes.budget.totalSpent + newItem.spentAmount).toFixed(2)
          ),
          noActiveTimeActivities: projectRes.budget.noActiveTimeActivities
        }
      }

      return app.service('/api/project').patch(expenseObj.projectId, updateObj)
    })
    .then(_projectUpdateRes => {
      callback(newItem)
    })
    .catch(err => {
      app.debug('PageExpense: _onAddBudgetExpense error', err)
    })
}

function _createExpense (
  createObj,
  items,
  deletedItemIds,
  fileObj,
  bDeleteAttachment,
  closePoIds,
  contactData,
  callback
) {
  const bSendQuickbook = createObj.bSendQuickbook
  delete createObj.bSendQuickbook

  const expenseInfo = {
    action: 'create',
    expenseId: null,
    createData: createObj,
    items: items || [],
    deletedItemIds: deletedItemIds || [],
    fileData: fileObj || null,
    bDeleteAttachment: bDeleteAttachment,
    closePoIds: closePoIds || [],
    contactData: contactData || null,
    isQuickbookConnected: app.isQuickbookConnected(),
    bSendQuickbook: bSendQuickbook
  }

  app.service('/api/expense/create').timeout = 5000
  app
    .service('/api/expense/create')
    .create(expenseInfo)
    .then(expenseRes => {
      callback(null, expenseRes)
    })
    .catch(err => {
      callback(err, null)
    })
}

function _createQuickbookExpense (createObj, callback) {
  if (app.isQuickbookConnected()) {
    app
      .service('/api/quickbook/expense')
      .create(createObj)
      .then(quickBookRes => {
        callback(null, quickBookRes)
      })
      .catch(quickbkErr => {
        callback(quickbkErr, null)
      })
  } else {
    callback(null, null)
  }
}

function _updateExpense (
  updateObj,
  expenseId,
  items,
  deletedItemIds,
  fileObj,
  bDeleteAttachment,
  closePoIds,
  contactData,
  callback
) {
  const bSendQuickbook = updateObj.bSendQuickbook
  delete updateObj.bSendQuickbook

  const expenseInfo = {
    action: 'update',
    expenseId: expenseId,
    createData: updateObj,
    items: items || [],
    deletedItemIds: deletedItemIds || [],
    fileData: fileObj || null,
    bDeleteAttachment: bDeleteAttachment,
    closePoIds: closePoIds || [],
    contactData: contactData || null,
    isQuickbookConnected: app.isQuickbookConnected(),
    bSendQuickbook: bSendQuickbook
  }

  app
    .service('/api/expense/create')
    .create(expenseInfo)
    .then(_res => {
      callback(null)
    })
    .catch(err => {
      callback(err, null)
    })
}

function _getProjectBudgetItems (
  projectId,
  phaseNo,
  keyword,
  excludeIds,
  callback
) {
  const itemParams = {
    query: {
      type: 'expense-activity',
      projectId: projectId,
      $client: {
        subObjects: {
          contact: ['id', 'company'],
          project: ['id', 'title']
        }
      },
      $sort: {
        phaseNo: 1,
        orderNo: 1
      }
    }
  }

  if (phaseNo) {
    itemParams.query.phaseNo = phaseNo
  }

  if (keyword) {
    const pattern = keyword
      .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
      .replace(/\$/g, '$$$$')
    itemParams.query.title = { $regex: pattern, $options: 'i' }
  }

  if (excludeIds && excludeIds.length > 0) {
    itemParams.query._id = {
      $nin: excludeIds
    }
  }

  app
    .service('/api/project/budgetitem')
    .find(itemParams)
    .then(itemRes => {
      if (itemRes) {
        const options = []
        itemRes.data.map(item => {
          item.label = item.title
          item.value = item.id
          item.project.contact = item.contact

          options.push(item)
        })

        callback(options)
      } else {
        callback([])
      }
    })
    .catch(err => {
      app.debug('ExpenseUtil: _getContactBudgetItems err', err)
      callback([])
    })
}

function _onSelectBudgetExpense (supplierId, budgetItem, callback) {
  const params = {
    query: {
      contactId: supplierId,
      budgetItemId: budgetItem.id,
      bClosed: false,
      $client: {
        subObjects: {
          purchaseOrder: ['invoiceNo', 'total']
        }
      }
    }
  }

  const newItem = _.cloneDeep(budgetItem)

  return app
    .service('/api/project/budgetitemsupplier')
    .find(params)
    .then(itemSupplierRes => {
      newItem.budgetItemId = budgetItem.id
      newItem.budgetItem = {
        title: budgetItem.title,
        bUseTotal: budgetItem.bUseTotal,
        noHours: budgetItem.noHours,
        pricePerHour: budgetItem.pricePerHour,
        total: budgetItem.total
      }
      newItem.id = null
      newItem.title = budgetItem.title
      newItem.total = budgetItem.total
      newItem.invoiceTotal = budgetItem.total
      newItem.selected = true
      newItem.budgetItemSupplier = null
      newItem.budgetItemSupplierId = null

      if (itemSupplierRes && itemSupplierRes.data.length > 0) {
        const itemSupplier = itemSupplierRes.data[0]
        newItem.budgetItemSupplier = itemSupplier
        newItem.budgetItemSupplierId = itemSupplier.id

        callback(newItem)
      } else {
        const supplierObj = {
          contactId: supplierId,
          projectId: budgetItem.projectId,
          budgetItemId: budgetItem.id,
          purchaseOrderId: null
        }

        return app
          .service('/api/project/budgetitemsupplier')
          .create(supplierObj)
      }
    })
    .then(itemSupplier => {
      if (itemSupplier) {
        newItem.budgetItemSupplier = itemSupplier
        newItem.budgetItemSupplierId = itemSupplier.id

        callback(newItem)
      }
    })
    .catch(err => {
      app.debug('ExpenseUtil: _onSelectBudgetExpense err', err)
    })
}

function _createContact (contactData, callback) {
  if (contactData) {
    const contactObj = {
      company: contactData.company,
      addresses: [
        {
          type: 'Office',
          street: '',
          streetNumber: '',
          postcode: '',
          city: '',
          country: app.teamCountry
        }
      ]
    }

    app
      .service('/api/contact')
      .create(contactObj)
      .then(contactRes => {
        if (contactRes) {
          callback(contactRes)
        } else {
          callback(null)
        }
      })
      .catch(contactErr => {
        app.debug('PageExpense: _saveContact Error', contactErr)
        callback(null)
      })
  } else {
    callback(null)
  }
}

function _validateExpenseTotalWithPO (items) {
  const invalidItem = _.find(items, item => {
    /* Calculate all expense items total */
    let totalInvoiceAmount = parseFloat(item.invoiceTotal)
    if (item.suppliers && item.suppliers.length > 0) {
      item.suppliers.forEach(supplier => {
        if (
          supplier.budgetItemSupplierId === item.budgetItemSupplierId &&
          supplier.expenses
        ) {
          supplier.expenses.forEach(expense => {
            if (!item.id || expense.expenseItemId !== item.id) {
              totalInvoiceAmount += parseFloat(expense.total)
            }
          })
        }
      })
    }

    /* If total expensed > PO amount of this item */
    if (item.purchaseOrder && totalInvoiceAmount > item.totalPoAmount) {
      return true
    }

    return false
  })

  return !invalidItem
}

function _createExpenseDataFromPO (purchaseorder, callback) {
  const expense = {
    contactId: purchaseorder.contactId,
    contact: purchaseorder.contact,
    subtotal: 0,
    total: 0,
    diff: 0
  }

  _getContactBudgetItems(purchaseorder.contactId, '', [], null, items => {
    items.forEach(item => {
      const poItem = _.find(
        purchaseorder.items,
        obj => item.budgetItem && obj.budgetItemId === item.budgetItem.id
      )
      if (poItem) {
        item.selected = true
        item.invoiceTotal = poItem.total || 0
      }
    })

    callback(expense, items)
  })
}

function _createExpenseDataFromSupplier (
  contact,
  project,
  budgetItem,
  supplier,
  callback
) {
  const expense = {
    contactId: supplier.contactId,
    contact: { company: supplier.supplierName },
    subtotal: 0,
    total: 0,
    diff: 0
  }

  _getContactBudgetItems(
    supplier.contactId,
    '',
    [],
    supplier.supplierId,
    items => {
      items.forEach(item => {
        if (item.budgetItem && item.budgetItem.id === budgetItem.id) {
          item.selected = true
          item.invoiceTotal = budgetItem.total || 0
        }
      })

      callback(expense, items)
    }
  )
}

function _validateInvoiceNo (expenseId, contactId, invoiceNo, callback) {
  const params = {
    query: {
      invoiceNo: invoiceNo,
      contactId: contactId
    }
  }

  app
    .service('/api/expense/validate')
    .get(expenseId, params)
    .then(_result => {
      callback(false)
    })
    .catch(err => {
      if (err.message === 'Invoice number already exists') {
        callback(true)
      } else {
        callback(false)
      }
    })
}

function _initQuickbookItems (callback) {
  const quickbookOptions = {
    accounts: [],
    activities: [],
    paymentMethods: []
  }

  return app
    .service('/api/quickbook/options')
    .find({})
    .then(optionRes => {
      app.debug('ExpenseUtil::_initQuickbookItems - Quickbook data received')
      quickbookOptions.accounts = optionRes.accounts || []
      quickbookOptions.activities = optionRes.activities || []
      quickbookOptions.paymentMethods = optionRes.paymentMethods || []

      // Set options to storage
      app.setAsObject('quickbookOptions', quickbookOptions)

      if (callback) {
        callback(null, quickbookOptions)
      }
    })
    .catch(err => {
      app.debug('ExpenseUtil::initQuickbookDetails - Error ', err)

      if (callback) {
        callback(err)
      }
    })
}

function _getQuickbookItems () {
  return (
    app.getAsObject('quickbookOptions') || {
      accounts: [],
      activities: [],
      paymentMethods: []
    }
  )
}

function _reloadQuickbookItems (type, callback) {
  let syncRequest = null
  if (type === 'quickbookAccount' || type === 'quickbookActivity') {
    syncRequest = app.service('/api/quickbook/syncaccount').create({})
  } else if (type === 'quickbookPaymentMethod') {
    syncRequest = app.service('/api/quickbook/syncpaymentmethod').create({})
  }

  if (syncRequest) {
    syncRequest
      .then(() => {
        _initQuickbookItems((syncErr, quickbookOptions) => {
          if (syncErr) {
            app.debug('ExpenseUtil::_reloadQuickbookItems - Error', syncErr)
          } else {
            callback(quickbookOptions)
          }
        })
      })
      .catch(err => {
        app.debug('ExpenseUtil::_reloadQuickbookItems - Error', err)
      })
  }
}

const ExpenseUtil = {}
ExpenseUtil.getProjects = _getProjects
ExpenseUtil.getContactBudgetItems = _getContactBudgetItems
ExpenseUtil.onAddBudgetExpense = _onAddBudgetExpense
ExpenseUtil.createExpense = _createExpense
ExpenseUtil.updateExpense = _updateExpense
ExpenseUtil.getProjectBudgetItems = _getProjectBudgetItems
ExpenseUtil.onSelectBudgetExpense = _onSelectBudgetExpense
ExpenseUtil.onCreateContact = _createContact
ExpenseUtil.validateExpenseTotalWithPO = _validateExpenseTotalWithPO
ExpenseUtil.createExpenseDataFromPO = _createExpenseDataFromPO
ExpenseUtil.createExpenseDataFromSupplier = _createExpenseDataFromSupplier
ExpenseUtil.createQuickbookExpense = _createQuickbookExpense
ExpenseUtil.getExpenseDetails = _getExpenseDetails
ExpenseUtil.validateInvoiceNo = _validateInvoiceNo
ExpenseUtil.initQuickbookItems = _initQuickbookItems
ExpenseUtil.getQuickbookItems = _getQuickbookItems
ExpenseUtil.reloadQuickbookItems = _reloadQuickbookItems

export default ExpenseUtil
